import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Transition } from "react-transition-group";
import { getTrueClasses } from "../../../../../helpers";
import { TOOLS_TABS } from "../../content/index.content";
import Item from "./Item";
import "./index.scss";

const DURATION = 100;

const DEFAULT_STYLE = {
  transition: `opacity ${DURATION}ms ease-in-out`,
  opacity: 0,
};

const TRANSITION_STYLES = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const Element = (props) => {
  const {
    title,
    subtitle,
    url,
    isBlank,
    action,
    label,
    category,
    onClickHandle,
    isBfOffer,
    updateState,
    children,
    icon,
    isLink,
    isIndicator,
    isButtonPricing,
    logo,
  } = props;

  const [open, setOpen] = useState(false);
  const [openDrop, setOpenDrop] = useState(false);

  const toggle = useCallback(() => {
    const newOpen = !open;
    const newOpenDrop = !openDrop;

    setOpen(newOpen);
    setOpenDrop(newOpenDrop);
    updateState && !newOpenDrop && updateState("toolsTab", TOOLS_TABS.SITE);
  }, [open, openDrop, updateState]);

  return (
    <div
      className={getTrueClasses(
        "GCL-H-E",
        isLink && "GCL-H-E_link",
        isBfOffer && "GCL-H-E_bfOffer",
        isButtonPricing && "GCL-H-E_pricing",
        isIndicator && "GCL-H-E_indicator"
      )}
      onMouseEnter={toggle}
      onMouseLeave={toggle}
    >
      <Item
        title={title}
        subtitle={subtitle}
        url={url}
        isBlank={isBlank}
        action={action}
        label={label}
        category={category}
        onClickHandle={onClickHandle}
        isBfOffer={isBfOffer}
        icon={icon}
        isLink={isLink}
        logo={logo}
      />

      {children && (
        <div className="GCL-H-E-TD">
          <Transition in={open} timeout={DURATION}>
            {(state) => (
              <div
                style={{
                  ...DEFAULT_STYLE,
                  ...TRANSITION_STYLES[state],
                }}
              >
                {children}
              </div>
            )}
          </Transition>
        </div>
      )}
    </div>
  );
};

Element.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  class: PropTypes.string,
  hint: PropTypes.string,
  onClickHandle: PropTypes.func,
  onClickClose: PropTypes.func,
  className: PropTypes.string,
  setIsSite: PropTypes.func,
};

export default Element;
